import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// Components
import CheckViewTable from "./CheckViewTable"; //reused table component
//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
//number format plugin
import numeral from "numeral";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import MessageBox from "../../components/MessageBox/MessageBox";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#c1c3d8",
		display:"none"
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(89, 178, 89, 0.09)",
		padding: "1rem",
		border: "1.5px solid #59b259",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #59b259",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	miniTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#4f537e",
	},
});

const CheckView = () => {
	const { chkno } = useParams();
	const branchIdNo = get_cookies('branchidno')
	const [purchaseType, setPurchaseType] = useState([]);
	const [supplier, setSupplier] = useState([]);
	// const [glAccounts, setGlAccounts] = useState([]);
	const [supplierId, setSupplierId] = useState([]);
	const [checkType, setCheckType] = useState([]);
	const [reference, setReference] = useState('');
	const [cleared, setCleared] = useState('');
	const [printed, setPrinted] = useState('');
	const [status, setStatus] = useState('');
	const [allocation, setAllocation] = useState('');
	const classes = useStyles();
	const [poTotal, setPoTotal] = useState(0);
	const [notes, setNotes] = useState('');
	const [selectedDate, setSelectedDate] = React.useState(format(new Date(), "yyyy-MM-dd"));

	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(false);

	const [showModal, setShowModal] = useState(false);
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");

	let history = useHistory();
	const [items, setItems] = useState([]); //data to display in table


	const handleDateChange = (date) => {
		date = format(date, "yyyy-MM-dd");
		setSelectedDate(date);
	};


	const checkSupplierProps = {
		options: checkType,
		getOptionLabel: (option) => option.type,
	};
	const selectSupplierProps = {
		options: supplier,
		getOptionLabel: (option) => option.suppliername,
	};
	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const getCheckDetails = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'/check_view', {
			params:{
				chkno: chkno,
				jc_user_id_no: branchIdNo
			}
		}).then((res)=>{
			//preparing arrays for display in dropdown
			const supplierObj = {
				suppliername: res.data.data[0].general_info.payto
			};
			const checkObj = {
				type: res.data.data[0].general_info.type
			};
			let supplierArray = [supplierObj];
			let checkTypeArray = [checkObj];
			setSupplier(supplierArray);
			setCheckType(checkTypeArray);
			setReference(res.data.data[0].general_info.reference);
			setSelectedDate(res.data.data[0].general_info.date);
			setPoTotal(res.data.data[0].general_info.grandtotal);
			setNotes(res.data.data[0].general_info.notes);
			setItems(res.data.data[1].item_info);
			setCleared(res.data.data[0].general_info.cleared);
			setPrinted(res.data.data[0].general_info.printed);
			setStatus(res.data.data[0].general_info.status);
			setAllocation(res.data.data[0].general_info.allocation);
		}).catch((error)=>{
		//console.log(error.message);
		});
	}
	

	const data = async () => {
		// getSupplierList();
		// getGlAccountList();
		getCheckDetails();
	};	

	// chkno:1163
	// jc_uname:postmanapi
	// jc_u_idno:DAVAOHQ

// const approve_check = async () => {
// 	setBtnDisabled(true); // disable button to avoid multiple saves
// 	setShowModal(true); //show loading/please wait modal
// 	const formData = new FormData();
// 	formData.append("chkno", chkno);
// 	formData.append("jc_uname", get_cookies('username'));
// 	formData.append("jc_u_idno", branchIdNo);

// 	await axios.post(process.env.REACT_APP_API_URL+'approve_check', formData, {
// 		headers: {
// 			'Content-Type': 'multipart/form-data'
// 			}
// 		}).then(function (res) {
// 			setShowModal(false); //hide loading/please wait modal
// 			setShowMsgBox(true);
// 			setMsg("Approved Check #"+chkno);
// 			setMsgType("success");
// 			setTimeout(() => {
// 				setShowMsgBox(false);
// 				setBtnDisabled(false); // re-enable
// 				history.push('/account/');
// 			}, 2000)
// 		  }).catch(function (error) {
// 			setShowModal(false); //hide loading/please wait modal 
// 			setShowMsgBox(true);
// 			setMsg("Something went wrong: "+error);
// 			setMsgType("warning");
// 			setTimeout(() => {
// 				setShowMsgBox(false);
// 				setBtnDisabled(false); // re-enable
// 			}, 2500)
// 		  });
// }

	return (
		<div className="page">
					<div className="page-header">
									<div className="page-icon">
										<LoyaltyTwoTone />
									</div>
									<NavLink to={"/account"}><h4 style={{color:"#339933"}}>Accounts</h4></NavLink>
									<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
									<NavLink to={"/account/check-transaction-history"}><h4 style={{color:"#339933"}}>Check Transaction History</h4></NavLink>
									<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
									<h4>Check View #{chkno}</h4>
					</div>
					{supplier.length>0 && checkType.length>0 ? (
						<div className="page-container">
						<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
						<Card className={classes.card}>
						<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
									Check View
								</div>
								<div className={classes.title}>
									Check View
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
							</Grid>
							<Grid
							
								item
								xs={2}
								className={classes.buttonContainer}
							>
							</Grid>
							<Grid container spacing={2}>	
								<Grid item xs="12" md={6} lg={6} xl={6}>
									<form noValidate autoComplete="off">
										<MuiPickersUtilsProvider utils={DateFnsUtils}>
											<KeyboardDatePicker
											disableToolbar
											variant="inline"
											format="MMM dd, yyyy"
											id="date-picker-inline"
											label="Date picker inline"
											value={selectedDate}
											disabled={true}
											inputVariant="outlined"
											margin="normal"
											className={classes.date}
											KeyboardButtonProps={{
												"aria-label": "change date",
											}}
											InputProps={{
												readOnly: true,
											  }}/>
										</MuiPickersUtilsProvider>
										<Autocomplete
													{...checkSupplierProps}
													id="auto-complete"
													autoComplete
													includeInputInList
													defaultValue={checkType[0]||checkType[null]}
													className={classes.autoComplete}
													disabled={true}
													renderInput={(params) => (
														<TextField
															{...params}
															label="Select Type"
															margin="normal"
															variant="outlined"
														/>
													)}
													onChange={(event, newValue) => {
														if (!newValue == "" || !newValue == null){
															console.log(newValue);
															setPurchaseType(newValue.type);
														}
													}}
													InputProps={{
														readOnly: true,
													  }}
										/>
										<Autocomplete
										{...selectSupplierProps}
										id="auto-complete"
										autoComplete
										includeInputInList
										className={classes.autoComplete}
										defaultValue={supplier[0]||supplier[null]}
										disabled={true}
										renderInput={(params) => (
											<TextField
												{...params}
												label="Select Supplier"
												margin="normal"
												variant="outlined"
											/>
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												console.log(newValue.id);
												setSupplierId(newValue.id);
											}
										}}
										InputProps={{
											readOnly: true,
										  }}
										/>	
										<TextField
													style={{marginTop:"8px"}}
													id="outlined-required"
													label="Reference"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={reference} //to avoid label overlapping bug
													onChange={(e)=>{setReference(e.target.value)}}
													InputProps={{
														readOnly: true,
													  }}
										/>
											</form>
								</Grid>
								<Grid item xs="12" md={6} lg={6} xl={6}>
									    <TextField
													style={{marginTop:"21px"}}
													id="outlined-required"
													label="Cleared"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={cleared} //to avoid label overlapping bug
													InputProps={{
														readOnly: true,
													  }}
										/>
										<TextField
													style={{marginTop:"20px"}}
													id="outlined-required"
													label="Printed"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={printed} //to avoid label overlapping bug
													InputProps={{
														readOnly: true,
													  }}
										/>
										<TextField
													style={{marginTop:"22px"}}
													id="outlined-required"
													label="Status"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={status} //to avoid label overlapping bug
													InputProps={{
														readOnly: true,
													  }}
										/>
										<TextField
													style={{marginTop:"17px"}}
													id="outlined-required"
													label="Allocation"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={allocation} //to avoid label overlapping bug
													InputProps={{
														readOnly: true,
													  }}
										/>			  
								</Grid>					  
							</Grid>
						</Grid>
					</div>
					<CardContent>
						<CheckViewTable items={items}/>
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div className={classes.infoTotalItem}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "+ numeral(poTotal).format('0,0.00')}
								</div>	
							</div>
						</div>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							value={notes} //to avoid label overlapping bug
							onChange={(e)=>{setNotes(e.target.value)}}
							className={classes.textarea}
							InputProps={{
								readOnly: true,
							  }}
						/>
					</CardContent>
				</Card>
					<br/>
					{/* <div className={classes.buttonContainer}>
						<Button disabled={btnDisabled} variant="contained" color="primary" onClick={()=>{approve_check()}}>
							Approve
						</Button>
					</div> */}
				</div>
				) : (<></>)}
		</div>
	);
};

export default CheckView;